module.exports = __webpack_public_path__ + "img/penjaminan-aman-ceo-orion.4ce4ad17.jpg";